// extracted by mini-css-extract-plugin
export default {"FooterMain":"Page404_FooterMain__bfvTD","Error404":"Page404_Error404__fz92O"};